/**
 *Created by jmmartinez on 3/8/18
 * v.1.1 01/04/2019 Corregido error en propiedad valor de renderCampo.
 * v.1.2 05/04/2019 Separada la función busquedaCamposToFiltro.
 * v.1.3 01/05/2019 Añadida propiedad urlServicioRestful para las busquedas de FK
 * v.1.4 13/05/2019 Uso de getFiltroFromCampo
 * v.1.5 25/07/2019 En busquedaCamposToFiltro cambiada la condicion "if (valor === false || valor" para los Checks FALSE
 * v.1.6 05/11/2019 Añadido botón para limpiar opciones
 *                  Añadiendo gestion de TabOrderManager
 *                  Añadida propiedad tabOrderManager en ComponenteEntrada
 * v.1.7 10/12/2019 Añadido filtro de búsqueda ISNOTNULL e ISNULL.
 * v.1.8 23/04/2020 Añadido filtro de búsqueda MENORIGUALONULL.
 * v.1.9 21/09/2020 Añadido uso de propiedad "nuevaLinea" en campos de ordenación para forzar salto
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 26/10/2020 Usamos la propiedad valoresIgnorar para no incluirlo en el filtro.
 * v.2.2 09/11/2020 Añadido FILTRO_OR para las condiciones que contienen un array de ORs dentro
 * v.2.3 09/04/2021 En busquedaCamposToFiltro añadimos todos los campos pero marcamos si por el valor que tiene no hay que filtrar él.
 *                      Es necesario para qel proceso en FormularioGrid,
 * v.2.4 06/07/2021 Añadidos FILTROS35 para compatibidad conFramework35.
 *                  Añadida propiedad usarFiltros35
 *
 *
 * v.2.5 05/06/2022 Fusion Planifikator y Sidemur
 * v.2.6 21/06/2022 En renderCampo hemos añadido un DIV para poder formatear con FLEX: <div className="formulariogridbusqueda_contenido">
 **/

import React from 'react'

import PropTypes from 'prop-types';
import {Col, Container, Row} from "react-grid-system";
import {Button} from "@blueprintjs/core";
import ComponenteEntrada from  "./ComponenteEntrada";
import {getFiltroFromCampo, getFiltroFromCampo35} from "../utils/FiltroGridUtils";
import TabOrderManager from "../utils/TabOrderManager";
import {contiene} from "../utils/ArrayUtils";
import {CAMPOTIPO_CHECK, CAMPOTIPO_FECHAPERIODO} from "./TiposCampos";
import "../../resources/css/formulariogridbusqueda.css"

export const FILTRO_NODEFINIDO = 0;
export const FILTRO_LIKE = 1;
export const FILTRO_STARTING = 2;
export const FILTRO_CONTAINING = 3;
export const FILTRO_MAYORIGUAL = 4;
export const FILTRO_MENORIGUAL = 5;
export const FILTRO_DISTINTO = 6;
export const FILTRO_IGUAL = 7;
export const FILTRO_MAYOR = 8;
export const FILTRO_MENOR = 9;
export const FILTRO_ENTRE= 10;
export const FILTRO_ENTREFECHAS= 11;
export const FILTRO_ISNOTNULL= 12;
export const FILTRO_ISNULL= 13;
export const FILTRO_MAYORIGUALONULL= 14;
export const FILTRO_MENORIGUALONULL= 15;
export const FILTRO_INARRAY= 16;
export const FILTRO_OR= 99;


export const FILTRO35_NODEFINIDO= 0;
export const FILTRO35_LIKE= 1;
export const FILTRO35_STARTING= 2;
export const FILTRO35_CONTAINING= 3;
export const FILTRO35_IGUAL= 4;
export const FILTRO35_MAYOR= 5;
export const FILTRO35_MAYORIGUAL= 6;
export const FILTRO35_MENOR= 7;
export const FILTRO35_MENORIGUAL= 8;
export const FILTRO35_DISTINTO= 9;
export const FILTRO35_ENTRE= 10;
export const FILTRO35_ENTREFECHAS= 11;

export const BUSQUEDACAMPOTIPO_NODEFINIDO = 0;
export const BUSQUEDACAMPOTIPO_CADENA = 'CADENA';
export const BUSQUEDACAMPOTIPO_CHECK = 'CHECK';
export const BUSQUEDACAMPOTIPO_COMBO = 'COMBO';
export const BUSQUEDACAMPOTIPO_TIPO = 'TIPO';
export const BUSQUEDACAMPOTIPO_FECHAPERIODO = 'FECHAPERIODO';
export const BUSQUEDACAMPOTIPO_OPCIONES = 'OPCIONES';
export const BUSQUEDACAMPOTIPO_COMBOOBJETOS = 'COMBOOBJETOS';

class FormularioGridBusqueda extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datosBusqueda: props.datosBusqueda,
            busquedaCampos: props.busquedaCampos,
            camposCheckDesactivados: {},
            urlServicioRestful: props.urlServicioRestful,
            camposRows: this.calcularCamposRows(props.busquedaCampos),
            className: props.className,
            filaClassName: props.filaClassName,
        }

        /*
        console.log ("----- CONSTRUCTOR ------");
        console.log("datosBusqueda: ", props.datosBusqueda);
        */

        this.tabOrderManager= new TabOrderManager();
        this.tabOrderManager.generarTabOrdersDeCamposBusqueda(props.busquedaCampos);
        //this.tabOrderManager.log();
    }



    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};
        /*
        if(nextProps.busquedaCampos !== prevState.busquedaCampos){
            newState.busquedaCampos= nextProps.busquedaCampos;
        }
        */
        if(nextProps.datosBusqueda !== prevState.datosBusqueda){
            newState.datosBusqueda= nextProps.datosBusqueda;
        }

        /*
        console.log ("----- getDerivedStateFromProps ------");
        console.log("datosBusqueda: ", nextProps.datosBusqueda);
        */

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }



    renderCampos = () => {
        const {className, camposRows} = this.state;
        return(
            <Container fluid={true} className={className}>
                {
                    camposRows.map ( (row, index) => {
                        return this.renderCamposRow(row, index);
                    })
                }
            </Container>
        );
    }

    renderCamposRow = (row, index) => {
        const {filaClassName} = this.state;
        return(
            <Row key={index} className={filaClassName}>
                {
                    row.map ( (campo, indexRow) => {
                        return this.renderCampo(campo, indexRow);
                    })
                }
            </Row>
        );
    }

    renderCampo = (campo, index) => {
        const {datosBusqueda, columnaClassName, urlServicioRestful} = this.state;
        let valorMostrar= datosBusqueda && datosBusqueda[campo.campo] ? datosBusqueda[campo.campo] : null;

        //console.log("************ RenderCampo: ****************", campo);
        //console.log("valor: ", datosBusqueda[campo.campo]);
        return(
            <Col key={index} md={campo.cols}>
               <div className="formulariogridbusqueda_contenido">
                   <ComponenteEntrada
                                       urlServicioRestful={urlServicioRestful}
                                       campo={campo}
                                       valor={valorMostrar}
                                       index={index}
                                       onChange={this.changeCampo}
                                       tabOrderManager={this.tabOrderManager}
                                       labelInLine={true}
                   />
               </div>
            </Col>
        )
    }

    calcularCamposRows = (campos) => {
        let anchoMaximo= 12;
        let camposRows= [];
        let anchoRowActual=0;
        let rowActual= []
        campos.forEach ( (campo) => {
            let nuevaLinea= campo.nuevalinea && Boolean(campo.nuevalinea);
            if (campo.cols + anchoRowActual <= anchoMaximo && !nuevaLinea){
                rowActual.push(campo);
                anchoRowActual += campo.cols;
            }
            else{
                //Añadimos la fila actual
                camposRows.push(rowActual);
                rowActual= [campo];
                anchoRowActual= campo.cols;
            }
        });
        //Añadimos la ultima row
        if (rowActual.length > 0)
            camposRows.push(rowActual);

        return camposRows;
    }

    changeCampo = (campo, valor) => {
        const {datosBusqueda, camposCheckDesactivados} = this.state;
        const {onChangeFiltro} = this.props;

        /*
        console.log("FormularioGrid - changeCampo");
        console.log("Campo: ", campo.campo);
        console.log("Valor: ", valor);
        */

        let newDatosBusqueda= {...datosBusqueda};
        newDatosBusqueda[campo.campo]= valor;

        //console.log("newDatosBusqueda: ", newDatosBusqueda);

        ///TODO: Si es un SelectorClase, guardar el texto, y si es un PeriodoTiempo, guardar el tipo.

        this.setState({datosBusqueda: newDatosBusqueda}, () => {
            onChangeFiltro && onChangeFiltro(newDatosBusqueda);
        });
    }

    busquedaCamposToFiltro= () => {
        const {busquedaCampos, datosBusqueda} = this.state;
        const {usarFiltros35} = this.props;


        console.log(" XXXXXX --- BusquedaCamposToFiltro:");
        console.log("busquedaCampos: ", busquedaCampos);
        console.log("datosBusqueda: ", datosBusqueda);


        //Generamos el objeto filtro
        let filtro= {
            condiciones: [],
            orden: []
        };

        busquedaCampos.forEach ( (campo) => {
            //console.log ("campo: ", campo);
            let valor= datosBusqueda[campo.campo];
            let valor2= null;
            //NUEVO:
            let valoresIgnorar= campo.valoresIgnorar ? campo.valoresIgnorar : [];
            //console.log("valor: ", valor);
            if (valor === false || valor) {
                //console.log("Dentro");
                let filtroCampo = usarFiltros35 ? getFiltroFromCampo35(campo, valor, valor2) : getFiltroFromCampo(campo, valor, valor2);
                if (contiene(valoresIgnorar, valor))
                    filtroCampo.noFiltrar= true;
                filtro.condiciones.push(filtroCampo);
            }

        })
        //console.log("Filtro: ", filtro);
        return filtro;
    }

    buscar = () => {
        const {onBuscar} = this.props;
        let filtro= this.busquedaCamposToFiltro();
        onBuscar && onBuscar(filtro);
    }

    limpiar = () => {
        const {gridConfig, onChangeFiltro} = this.props;
        //console.log("LIMPIAR");
        let newDatosBusqueda= this.inicializarDatosBusqueda();
        this.setState({datosBusqueda: newDatosBusqueda});
        onChangeFiltro && onChangeFiltro(newDatosBusqueda);
    }


    inicializarDatosBusqueda= () => {
        const {busquedaCampos} = this.props;
        let newDatosBusqueda= {};
        if (busquedaCampos) {
            busquedaCampos.forEach((campo) => {
                if (campo.tipo === CAMPOTIPO_FECHAPERIODO){

                }
                else {
                    if (campo.tipo === CAMPOTIPO_CHECK){
                        newDatosBusqueda[campo.campo] = campo.valor;
                    }
                    else {
                        if (campo.valor) {
                            newDatosBusqueda[campo.campo] = campo.valor;
                        }
                    }
                }
            });
        }
        return newDatosBusqueda;
    }

    render() {
        const{datosBusqueda} = this.state;

        /*
        console.log("RENDER FORMULARIO GRID BUSQUEDA ------");
        console.log("datosBusqueda: ", datosBusqueda);
        */
        const {className} =  this.state;
        return (
            <div>
                <Container fluid={true} className={className} style={{backgroundColor: "#eeeeee", margin: 6, padding: 6}}>
                    {
                        this.renderCampos()
                    }
                </Container>
                <Button icon="search" onClick={this.buscar}>Buscar</Button>
                <Button style={{marginLeft: 10}} icon="clean" onClick={this.limpiar}>Limpiar</Button>
            </div>
        );
    }
}


FormularioGridBusqueda.propTypes = {
    busquedaCampos: PropTypes.array.isRequired,
    datosBusqueda: PropTypes.object,
    urlServicioRestful: PropTypes.string,
    className: PropTypes.string,
    filaClassName: PropTypes.string,
    usarFiltros35: PropTypes.bool,
}

export default FormularioGridBusqueda
